import {
  object,
  array,
  number,
  collection,
  string,
  date,
} from '@gogame/schemas';

import {
  NAME,
  APPLICATIONS,
  TAGS,
  REQUESTED_BY,
  JIRA_TASK,
  DESCRIPTION,
  STATE_SCHEDULES,
  EXPIRATION_DATE,
  UNARCHIVE_DATE,
  ORIGINAL,
  CONCEPT_FAMILIES,
} from 'scenes/Gallery/GalleryPage/Concepts/constants';
import {
  DESIGNER,
  OUTSOURCE_STUDIO_ID,
  FILE,
  FILE_GUID,
  BUSINESS_PARTNERS,
  TESTED,
} from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { creativeValidationSchema } from 'scenes/Gallery/GalleryPage/Creatives/schemas/creative';

export const getValidationSchema = ({
  isAllowArchiving,
  isAllowConceptFamilies,
  isAllowOutsourceStudio,
  isAllowDesigner,
  isAllowRequestedBy,
  isAllowJiraTask,
  isAllowBusinessPartner,
  isAllowTested,
}) => {
  let schema = object({
    [NAME]: string().required('Name is required'),
    [APPLICATIONS]: array(number()).required('Applications is required'),
    [TAGS]: array(number()),
    [DESCRIPTION]: string(),
    [STATE_SCHEDULES]: collection(object({ state: number(), date: string() })),
  });

  if (isAllowArchiving) {
    schema = schema.shape({
      [EXPIRATION_DATE]: date(),
      [UNARCHIVE_DATE]: date(),
    });
  }

  if (isAllowJiraTask) {
    schema = schema.shape({
      [JIRA_TASK]: string().url('Jira Task URL must be a valid URL'),
    });
  }

  if (isAllowRequestedBy) {
    schema = schema.shape({
      [REQUESTED_BY]: number().required('Requested by is required'),
    });
  }

  if (isAllowConceptFamilies) {
    schema = schema.shape({
      [CONCEPT_FAMILIES]: array(number()),
    });
  }

  let creativeSchema = creativeValidationSchema.shape({
    [FILE]: object(),
    [FILE_GUID]: string(),
  });

  if (isAllowDesigner) {
    creativeSchema = creativeSchema.shape({
      [DESIGNER]: number(),
    });
  }
  if (isAllowOutsourceStudio) {
    creativeSchema = creativeSchema.shape({
      [OUTSOURCE_STUDIO_ID]: number(),
    });
  }
  if (isAllowBusinessPartner) {
    creativeSchema = creativeSchema.shape({
      [BUSINESS_PARTNERS]: array(number()),
    });
    schema = schema.shape({
      [BUSINESS_PARTNERS]: array(number()),
    });
  }
  if (isAllowTested) {
    creativeSchema = creativeSchema.shape({
      [TESTED]: number().required('Tested is required'),
    });
  }

  return schema.shape({
    [ORIGINAL]: creativeSchema,
  });
};
